/* Bear Blanks buy-box (2026-08-22). Yalnız product.blank şablonunda <script defer> ile yüklenir.
 * Renk tıkla → Section Rendering (section_id=bear-blank-buybox&option_values=<colorValueId>) → .bbx swap
 * → history ?variant= → tema galerisi (Flickity selectCell). Beden×adet → tek POST /cart/add.js {items:[...]}
 * → tema drawer'ını aynı yolla (theme.Cart.prototype._onProductAdded) yeniler/açar.
 * Olaylar: bear:blank:change {n,total,items} · bear:blank:color {valueId,name,variantId,mediaId} · bear:blank:added {items,total,response}
 * Parlatma (22.08): swatch HSL sıralama + açık/koyu ✓ · hover tooltip + chip/ad canlı önizleme · galeri 'DTF-READY BLANK' rozeti ·
 * Description 'Read more' · sticky çubukta renk chip'i + 'Add N items — $X'.
 */
(function () {
  'use strict';
  if (window.BearBlank) { return; }

  var SECTION = 'bear-blank-buybox';
  var RUSH_VARIANT_ID = 42585512116302; /* cart-drawer.liquid ile aynı istisna */
  var state = { cartBlank: 0, cartLoaded: false, ctrl: null, io: null, flashT: null };

  function root() { return document.querySelector('.bbx[data-section="' + SECTION + '"]') || document.querySelector('.bbx'); }
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  function emit(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail || {}, bubbles: true })); } catch (e) {}
  }

  /* ---------- para ---------- */
  function money(cents) {
    var fmt = (window.theme && theme.moneyFormat) || '${{amount}}';
    var v = (Number(cents) || 0) / 100;
    var neg = v < 0; v = Math.abs(v);
    function grp(intStr, sep) { return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    var out;
    if (/amount_no_decimals_with_comma_separator/.test(fmt)) {
      out = grp(String(Math.round(v)), '.');
    } else if (/amount_with_comma_separator/.test(fmt)) {
      var p = v.toFixed(2).split('.'); out = grp(p[0], '.') + ',' + p[1];
    } else if (/amount_no_decimals/.test(fmt)) {
      out = grp(String(Math.round(v)), ',');
    } else {
      var q = v.toFixed(2).split('.'); out = grp(q[0], ',') + '.' + q[1];
    }
    var s = fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, out).replace(/<[^>]+>/g, '');
    return (neg ? '-' : '') + s;
  }
  function moneyShort(cents) { return money(cents).replace(/([.,]00)(?=\D|$)/, ''); }

  /* ---------- adet / toplam ---------- */
  function readQty(inp) {
    var q = parseInt(inp.value, 10);
    return (isFinite(q) && q > 0) ? q : 0;
  }
  function maxOf(inp) {
    var m = inp.getAttribute('data-max');
    if (m === null || m === '') { return null; }
    var n = parseInt(m, 10);
    return isFinite(n) ? n : null;
  }
  function compute(bx) {
    var n = 0, total = 0, items = [];
    qsa('.bbx-qty', bx).forEach(function (inp) {
      var q = readQty(inp);
      var row = closest(inp, '.bbx-row');
      if (q > 0) {
        n += q;
        var price = parseInt(inp.getAttribute('data-price'), 10) || 0;
        total += q * price;
        items.push({ id: parseInt(inp.getAttribute('data-id'), 10), quantity: q,
                     label: inp.getAttribute('data-label') || '', price: price, gtin: inp.getAttribute('data-gtin') || '' });
      }
      if (row) { row.classList.toggle('has-qty', q > 0); }
    });
    return { n: n, total: total, items: items };
  }
  function clampInput(inp, hard) {
    var q = readQty(inp), max = maxOf(inp), row = closest(inp, '.bbx-row');
    if (max !== null && q > max) {
      q = max; inp.value = max;
      if (row) { row.classList.add('is-maxed'); clearTimeout(row._bbxT); row._bbxT = setTimeout(function () { row.classList.remove('is-maxed'); }, 1600); }
    } else if (hard) {
      inp.value = q;
    }
    return q;
  }
  function render(bx) {
    if (!bx) { return null; }
    var s = compute(bx);
    var atc = qs('.bbx-atc', bx);
    if (atc && !bx.classList.contains('is-adding')) {
      var tpl = atc.getAttribute('data-label') || 'Add {n} items — {total}';
      var empty = atc.getAttribute('data-label-empty') || 'Select sizes & quantities';
      var txt = empty;
      if (s.n) {
        txt = tpl.replace('{n}', s.n).replace('{total}', money(s.total));
        if (s.n === 1) { txt = txt.replace(/\bitems\b/, 'item'); }
      }
      atc.textContent = txt;
      atc.disabled = !s.n;
    }
    var cn = qs('.bbx-cta-n b', bx); if (cn) { cn.textContent = s.n; }
    var cnw = qs('.bbx-cta-n', bx); if (cnw) { cnw.innerHTML = '<b>' + s.n + '</b> ' + (s.n === 1 ? 'item' : 'items'); }
    var ct = qs('.bbx-cta-total b', bx); if (ct) { ct.textContent = money(s.total); }
    var st = qs('.bbx-sticky-total', bx); if (st) { st.textContent = money(s.total); }
    var sn = qs('.bbx-sticky-n', bx); if (sn) { sn.textContent = s.n + (s.n === 1 ? ' item' : ' items'); }
    var sb = qs('.bbx-sticky-btn', bx);
    if (sb) { sb.textContent = s.n ? ('Add ' + s.n + (s.n === 1 ? ' item' : ' items') + ' \u2014 ' + money(s.total)) : (sb.getAttribute('data-label-empty') || 'Select sizes'); sb.classList.toggle('is-ready', s.n > 0); }
    shipbar(bx, s.total);
    emit('bear:blank:change', { n: s.n, total: s.total, items: s.items });
    return s;
  }

  /* ---------- kargo çubuğu ---------- */
  function shipbar(bx, formTotal) {
    var bar = qs('.bbx-shipbar', bx); if (!bar) { return; }
    var thr = parseInt(bar.getAttribute('data-threshold'), 10) || 27500;
    var flat = parseInt(bar.getAttribute('data-flat'), 10) || 2990;
    var tot = (state.cartBlank || 0) + (formTotal || 0);
    var pct = Math.max(0, Math.min(100, Math.round(tot * 100 / thr)));
    var fill = qs('.bbx-shipbar-fill', bar); if (fill) { fill.style.width = pct + '%'; }
    var t = qs('.bbx-shipbar-text', bar);
    var html;
    if (tot >= thr) {
      html = '<b>FREE blank shipping unlocked</b> &mdash; your blanks ship free via UPS.';
    } else if (tot > 0) {
      html = 'Add <b>' + money(thr - tot) + '</b> more in blanks for <b>FREE UPS shipping</b> <span class="bbx-shipbar-else">(otherwise flat ' + money(flat) + ')</span>';
    } else {
      html = 'Blank shipping: <b>' + money(flat) + ' flat</b> via UPS &middot; <b>FREE over ' + moneyShort(thr) + '</b>';
    }
    if (t) { t.innerHTML = html; }
    bar.classList.toggle('is-free', tot >= thr);
    bar.classList.toggle('is-progress', tot > 0 && tot < thr);
  }
  function loadCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var blank = 0;
        (c && c.items ? c.items : []).forEach(function (it) {
          /* cart-drawer.liquid ile aynı sınıflandırma: hizmet (requires_shipping=false), gift card, rush → sayılmaz;
             başlık/tip 'dtf' ya da 'transfer' içeriyorsa DTF; kalan her şey blank. */
          if (it.requires_shipping === false || it.gift_card || it.variant_id === RUSH_VARIANT_ID) { return; }
          var t = ((it.product_title || '') + ' ' + (it.product_type || '')).toLowerCase();
          if (t.indexOf('dtf') > -1 || t.indexOf('transfer') > -1) { return; }
          blank += (typeof it.final_line_price === 'number' ? it.final_line_price : (it.line_price || 0));
        });
        state.cartBlank = blank; state.cartLoaded = true;
        var bx = root(); if (bx) { shipbar(bx, compute(bx).total); }
      })
      .catch(function () {});
  }

  /* ---------- hata ---------- */
  function clearErrors(bx) {
    var ul = qs('.bbx-errors', bx); if (ul) { ul.innerHTML = ''; ul.hidden = true; }
    qsa('.bbx-row.is-error', bx).forEach(function (r) { r.classList.remove('is-error'); });
  }
  function showError(bx, msg, labels) {
    var ul = qs('.bbx-errors', bx); if (!ul) { return; }
    var li = document.createElement('li'); li.textContent = msg; ul.appendChild(li); ul.hidden = false;
    (labels || []).forEach(function (lb) {
      var row = qsa('.bbx-row', bx).filter(function (r) { return r.getAttribute('data-size') === lb; })[0];
      if (row) { row.classList.add('is-error'); }
    });
  }

  /* ---------- renk seçimi ---------- */
  function previewParam() {
    var m = location.search.match(/[?&]preview_theme_id=(\d+)/);
    return m ? '&preview_theme_id=' + m[1] : '';
  }
  function productBase(bx) {
    var rootUrl = (window.routes && routes.rootUrl) || '/';
    rootUrl = rootUrl.replace(/\/$/, '');
    return rootUrl + '/products/' + (bx.getAttribute('data-product-handle') || '');
  }
  function markSelected(bx, valueId, name) {
    qsa('.bbx-sw', bx).forEach(function (b) {
      var on = b.getAttribute('data-value-id') === valueId;
      b.classList.toggle('is-selected', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    qsa('.bbx-color-item', bx).forEach(function (b) { b.classList.toggle('is-selected', b.getAttribute('data-value-id') === valueId); });
    var nm = qs('.bbx-color-name', bx); if (nm && name) { nm.textContent = name; }
    var sw = qsa('.bbx-sw', bx).filter(function (b) { return b.getAttribute('data-value-id') === valueId; })[0];
    if (sw) { paintChip(qs('.bbx-color-cur', bx), sw); }
    syncSticky(bx);
  }
  /* ---------- renk chip'i / canlı önizleme / tooltip / HSL sıralama ---------- */
  function hexRgb(hex) {
    var m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(hex || '').trim()); if (!m) { return null; }
    var h = m[1]; if (h.length === 3) { h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]; }
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }
  function luminance(hex) {
    var c = hexRgb(hex); if (!c) { return null; }
    function lin(v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
    return 0.2126 * lin(c[0]) + 0.7152 * lin(c[1]) + 0.0722 * lin(c[2]);
  }
  function hsl(hex) {
    var c = hexRgb(hex); if (!c) { return null; }
    var r = c[0] / 255, g = c[1] / 255, b = c[2] / 255, mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn;
    var l = (mx + mn) / 2, sat = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1)), h = 0;
    if (d !== 0) {
      if (mx === r) { h = ((g - b) / d) % 6; } else if (mx === g) { h = (b - r) / d + 2; } else { h = (r - g) / d + 4; }
      h *= 60; if (h < 0) { h += 360; }
    }
    return { h: h, s: sat, l: l };
  }
  /* Renk sıralaması: nötrler (gri/beyaz/siyah) önce açıktan koyuya; sonra ton (kırmızı→turuncu→sarı→yeşil→mavi→mor),
     aynı ton kovasında açıktan koyuya. Hex'i olmayanlar en sona, kendi sırasıyla. */
  function colorKey(hex) {
    var c = hsl(hex); if (!c) { return [2, 0, 0]; }
    if (c.s < 0.13 || c.l > 0.94 || c.l < 0.07) { return [0, 0, 1 - c.l]; }
    var hh = (c.h + 15) % 360; /* kırmızılar (345-360) başa */
    return [1, Math.floor(hh / 30), 1 - c.l];
  }
  function sortByHue(list) {
    var arr = list.map(function (el, i) { return { el: el, i: i, k: colorKey(el.getAttribute('data-hex')) }; });
    arr.sort(function (a, b) { return a.k[0] - b.k[0] || a.k[1] - b.k[1] || a.k[2] - b.k[2] || a.i - b.i; });
    return arr.map(function (x) { return x.el; });
  }
  function sortSwatches(bx) {
    var row = qs('.bbx-sw-row', bx);
    if (row) {
      var sws = qsa('.bbx-sw', row);
      if (sws.some(function (b) { return b.hasAttribute('data-hex'); })) {
        sortByHue(sws).forEach(function (b) { row.appendChild(b); });
      }
      sws.forEach(function (b) { var L = luminance(b.getAttribute('data-hex')); b.classList.toggle('is-light', L !== null && L > 0.8); });
    }
    var ul = qs('.bbx-color-ul', bx);
    if (ul) {
      var items = qsa('.bbx-color-item', ul);
      if (items.some(function (b) { return b.hasAttribute('data-hex'); })) {
        sortByHue(items).forEach(function (b) { ul.appendChild(b.parentNode); });
      }
    }
    fitMore(bx);
  }
  function fitMore(bx) {
    var row = qs('.bbx-sw-row', bx), more = qs('.bbx-sw-more', bx), wrap = qs('.bbx-sw-wrap', bx);
    if (!row || !more) { return; }
    if (wrap && wrap.classList.contains('is-expanded')) { more.hidden = false; return; }
    more.hidden = row.scrollHeight <= row.clientHeight + 2;
  }
  /* chip: hex varsa düz renk; yoksa swatch görselinin kopyası; o da yoksa gri zemin */
  function paintChip(chip, sw) {
    if (!chip || !sw) { return; }
    var hex = sw.getAttribute('data-hex'), hex2 = sw.getAttribute('data-hex2');
    chip.innerHTML = ''; chip.style.background = ''; chip.style.backgroundImage = '';
    if (hex) {
      chip.style.background = hex;
      if (hex2) { chip.style.backgroundImage = 'linear-gradient(135deg,' + hex + ' 50%,' + hex2 + ' 50%)'; }
      return;
    }
    var img = sw.querySelector('img');
    if (img) { var c = img.cloneNode(false); c.removeAttribute('width'); c.removeAttribute('height'); c.loading = 'eager'; chip.appendChild(c); return; }
    var ab = sw.querySelector('.bbx-sw-fill--ab, .bbx-chip-ab');
    if (ab) { var s2 = document.createElement('span'); s2.className = 'bbx-chip-ab'; s2.textContent = ab.textContent; chip.appendChild(s2); }
  }
  function syncSticky(bx) {
    var src = qs('.bbx-color-cur', bx), dot = qs('.bbx-sticky-dot', bx), nm = qs('.bbx-color-name', bx), cn = qs('.bbx-sticky-cname', bx);
    if (src && dot) { dot.innerHTML = src.innerHTML; dot.style.cssText = src.style.cssText; }
    if (nm && cn) { cn.textContent = nm.textContent; }
  }
  function previewColor(bx, sw) {
    var chip = qs('.bbx-color-cur', bx), nm = qs('.bbx-color-name', bx); if (!chip || !nm) { return; }
    if (!bx._bbxPrev) { bx._bbxPrev = { html: chip.innerHTML, css: chip.style.cssText, name: nm.textContent }; }
    paintChip(chip, sw); nm.textContent = sw.getAttribute('data-name') || nm.textContent;
  }
  function restoreColor(bx) {
    var p = bx._bbxPrev; if (!p) { return; }
    var chip = qs('.bbx-color-cur', bx), nm = qs('.bbx-color-name', bx);
    if (chip) { chip.innerHTML = p.html; chip.style.cssText = p.css; }
    if (nm) { nm.textContent = p.name; }
    bx._bbxPrev = null;
  }
  function showTip(bx, sw) {
    var host = qs('.bbx-colors', bx); if (!host) { return; }
    var tip = qs('.bbx-tip', host);
    if (!tip) { tip = document.createElement('span'); tip.className = 'bbx-tip'; tip.setAttribute('role', 'tooltip'); host.appendChild(tip); }
    tip.textContent = sw.getAttribute('data-name') || '';
    var hr = host.getBoundingClientRect(), r = sw.getBoundingClientRect();
    tip.style.left = (r.left - hr.left + r.width / 2) + 'px';
    tip.style.top = (r.top - hr.top - 4) + 'px';
    tip.hidden = false;
  }
  function hideTip(bx) { var tip = qs('.bbx-tip', bx); if (tip) { tip.hidden = true; } }
  /* galeri sol-üst rozet — product-template'e dokunmadan DOM'a eklenir */
  function addGalleryBadge() {
    var g = document.querySelector('.product-single__media-group'); if (!g || g.querySelector('.bbx-gbadge')) { return; }
    try { if (getComputedStyle(g).position === 'static') { g.style.position = 'relative'; } } catch (e) {}
    var b = document.createElement('span'); b.className = 'bbx-gbadge'; b.textContent = 'DTF-READY BLANK'; b.setAttribute('aria-hidden', 'true');
    g.insertBefore(b, g.firstChild);
  }
  /* Description: ilk ~6 satır + Read more (yalnız taşıyorsa) */
  function initReadMore() {
    qsa('.bbd-clamp').forEach(function (c) {
      var btn = c.parentNode && c.parentNode.querySelector('.bbd-more'); if (!btn) { return; }
      var lim = parseFloat(getComputedStyle(c).fontSize) * 9.9;
      var tall = c.scrollHeight > lim + 24;
      c.classList.toggle('is-clampable', tall); btn.hidden = !tall;
    });
  }
  function scrollSwatchIntoView(bx) {
    var row = qs('.bbx-sw-row', bx), sel = qs('.bbx-sw.is-selected', bx);
    if (!row || !sel) { return; }
    if (row.scrollWidth > row.clientWidth + 4) {
      row.scrollLeft = Math.max(0, sel.offsetLeft - row.clientWidth / 2 + sel.offsetWidth / 2);
    }
  }
  function selectColor(valueId, name) {
    var bx = root(); if (!bx || !valueId) { return; }
    if (bx.getAttribute('data-color-id') === valueId && !bx.classList.contains('is-loading')) { closeList(bx); return; }
    if (state.ctrl) { try { state.ctrl.abort(); } catch (e) {} }
    var ctrl = ('AbortController' in window) ? new AbortController() : null; state.ctrl = ctrl;
    bx._bbxPrev = null; hideTip(bx);
    bx.classList.add('is-loading'); bx.setAttribute('aria-busy', 'true');
    markSelected(bx, valueId, name);
    var hadFocus = document.activeElement && closest(document.activeElement, '.bbx-sw, .bbx-color-item');
    var listOpen = (function () { var l = qs('.bbx-color-list', bx); return l && !l.hidden; })();
    var expanded = (function () { var r = qs('.bbx-sw-wrap', bx); return r && r.classList.contains('is-expanded'); })();
    var url = productBase(bx) + '?section_id=' + SECTION + '&option_values=' + encodeURIComponent(valueId) + previewParam();
    fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.bbx');
        if (!fresh) { throw new Error('no-bbx'); }
        var cur = root(); if (!cur) { return; }
        var y = window.pageYOffset;
        cur.parentNode.replaceChild(fresh, cur);
        if (expanded) { var w = qs('.bbx-sw-wrap', fresh); if (w) { w.classList.add('is-expanded'); } var mb = qs('.bbx-sw-more', fresh); if (mb) { mb.setAttribute('aria-expanded', 'true'); } }
        if (listOpen) { openList(fresh, false); }
        if (Math.abs(window.pageYOffset - y) > 2) { window.scrollTo(0, y); }
        if (hadFocus) { var sw = qs('.bbx-sw.is-selected', fresh); if (sw) { try { sw.focus({ preventScroll: true }); } catch (e) { sw.focus(); } } }
        scrollSwatchIntoView(fresh);
        updateHistory(fresh);
        selectMedia(fresh.getAttribute('data-media-id'));
        sortSwatches(fresh); syncSticky(fresh);
        render(fresh); initSticky(fresh);
        emit('bear:blank:color', { valueId: valueId, name: fresh.getAttribute('data-color'), variantId: fresh.getAttribute('data-variant-id'), mediaId: fresh.getAttribute('data-media-id') });
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') { return; }
        var cur = root(); if (!cur) { return; }
        cur.classList.remove('is-loading'); cur.removeAttribute('aria-busy');
        showError(cur, 'Could not load that color. Please try again.');
      });
  }
  function updateHistory(bx) {
    var vid = bx.getAttribute('data-variant-id'); if (!vid || !window.history || !history.replaceState) { return; }
    try {
      var u = new URL(location.href);
      u.searchParams.delete('option_values'); u.searchParams.set('variant', vid);
      history.replaceState(history.state, '', u.toString());
    } catch (e) {}
  }
  /* Tema galerisi: [data-product-main-slider] içindeki .product-single__media__slide[data-media-id] → Flickity.select(index)
     (theme.js _updateImages ile aynı yol); Flickity yoksa thumbnail'e tıkla. */
  function selectMedia(mediaId) {
    if (!mediaId) { return; }
    var slider = document.querySelector('[data-product-main-slider]'); if (!slider) { return; }
    var slide = slider.querySelector('.product-single__media__slide[data-media-id="' + mediaId + '"]'); if (!slide) { return; }
    var idx = Array.prototype.indexOf.call(slide.parentNode.children, slide); if (idx < 0) { return; }
    try {
      /* select(index, isWrap, isInstant): anlık atlama — arka plan sekmesinde rAF kısılınca yarım kalan animasyon olmasın */
      var fl = window.Flickity && Flickity.data(slider);
      if (fl) { fl.select(idx, false, true); return; }
    } catch (e) {}
    var th = document.querySelector('.product-single__thumbnails-block[data-thumb-index="' + idx + '"]');
    if (th) { th.click(); }
  }

  /* ---------- renk listesi ---------- */
  function openList(bx, focusSearch) {
    var l = qs('.bbx-color-list', bx); if (!l) { return; }
    l.hidden = false;
    qsa('.bbx-colors-toggle, .bbx-colors-cur', bx).forEach(function (b) { b.setAttribute('aria-expanded', 'true'); b.classList.add('is-open'); });
    if (window.innerWidth <= 767) { document.body.classList.add('bbx-list-open'); }
    var s = qs('.bbx-color-search', l);
    if (s && focusSearch && window.innerWidth > 767) { try { s.focus({ preventScroll: true }); } catch (e) { s.focus(); } }
  }
  function closeList(bx) {
    bx = bx || root(); if (!bx) { return; }
    var l = qs('.bbx-color-list', bx); if (!l || l.hidden) { return; }
    l.hidden = true;
    qsa('.bbx-colors-toggle, .bbx-colors-cur', bx).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); b.classList.remove('is-open'); });
    document.body.classList.remove('bbx-list-open');
  }
  function toggleList(bx) {
    var l = qs('.bbx-color-list', bx); if (!l) { return; }
    if (l.hidden) { openList(bx, true); } else { closeList(bx); }
  }
  function filterList(bx, q) {
    q = (q || '').trim().toLowerCase();
    var any = false;
    qsa('.bbx-color-item', bx).forEach(function (it) {
      var hit = !q || (it.getAttribute('data-name') || '').toLowerCase().indexOf(q) > -1;
      it.parentNode.hidden = !hit; if (hit) { any = true; }
    });
    var none = qs('.bbx-color-none', bx); if (none) { none.hidden = any; }
  }

  /* ---------- sepete ekle ---------- */
  function openDrawer() {
    try {
      if (window.theme && theme.Cart && theme.Cart.prototype && typeof theme.Cart.prototype._onProductAdded === 'function') {
        theme.Cart.prototype._onProductAdded(); return;
      }
    } catch (e) {}
    window.location.href = (window.routes && routes.cartUrl) || '/cart';
  }
  function addToCart(bx) {
    bx = bx || root(); if (!bx) { return; }
    if (bx.classList.contains('is-adding') || bx.classList.contains('is-loading')) { return; }
    qsa('.bbx-qty', bx).forEach(function (i) { clampInput(i, true); });
    var s = compute(bx);
    clearErrors(bx);
    if (!s.n) {
      var first = qs('.bbx-qty', bx);
      if (first) { try { first.focus({ preventScroll: false }); } catch (e) { first.focus(); } }
      return;
    }
    var atc = qs('.bbx-atc', bx);
    bx.classList.add('is-adding'); if (atc) { atc.disabled = true; atc.textContent = 'Adding…'; }
    var items = s.items.map(function (i) { return { id: i.id, quantity: i.quantity }; });
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; }, function () { return { ok: r.ok, status: r.status, json: null }; }); })
      .then(function (res) {
        bx.classList.remove('is-adding');
        if (!res.ok) {
          var j = res.json || {};
          var desc = (j.description || j.message || 'Could not add to cart. Please try again.');
          if (typeof desc === 'object') { desc = Object.keys(desc).map(function (k) { return desc[k]; }).join(' '); }
          desc = String(desc);
          var bad = s.items.filter(function (it) { return it.label && desc.indexOf('/ ' + it.label) > -1; }).map(function (it) { return it.label; });
          showError(bx, desc, bad);
          /* Shopify kısmi ekleme (422 ama "Only N items were added to your cart…"): sepet gerçekten değişti →
             adetleri sıfırla, çubuğu yenile ve drawer'ı aç; diğer 422'lerde yalnız sepet çubuğunu tazele. */
          if (/were added to your cart|added to your cart/i.test(desc)) {
            qsa('.bbx-qty', bx).forEach(function (i) { i.value = 0; });
            render(bx);
            emit('bear:blank:added', { items: s.items, total: s.total, response: res.json, partial: true });
            openDrawer();
          } else {
            render(bx);
          }
          loadCart();
          return;
        }
        qsa('.bbx-qty', bx).forEach(function (i) { i.value = 0; });
        render(bx);
        if (atc) {
          atc.textContent = 'Added ✓'; atc.classList.add('is-added'); atc.disabled = true;
          clearTimeout(state.flashT);
          state.flashT = setTimeout(function () { atc.classList.remove('is-added'); render(root()); }, 1600);
        }
        emit('bear:blank:added', { items: s.items, total: s.total, response: res.json });
        openDrawer();
        loadCart();
      })
      .catch(function () {
        bx.classList.remove('is-adding');
        showError(bx, 'Network error — please try again.');
        render(bx);
      });
  }

  /* ---------- mobil sticky ---------- */
  function initSticky(bx) {
    var atc = qs('.bbx-atc', bx), st = qs('.bbx-sticky', bx);
    if (!atc || !st || !('IntersectionObserver' in window)) { return; }
    if (state.io) { state.io.disconnect(); }
    state.io = new IntersectionObserver(function (entries) {
      var e = entries[0]; if (!e) { return; }
      st.hidden = e.isIntersecting;
      document.body.classList.toggle('bbx-sticky-on', !e.isIntersecting);
    }, { threshold: 0.01, rootMargin: '0px 0px -56px 0px' });
    state.io.observe(atc);
  }

  /* ---------- stepper ---------- */
  function step(btn, dir) {
    var wrap = closest(btn, '.bbx-qtywrap'); var inp = wrap && qs('.bbx-qty', wrap); if (!inp) { return; }
    var q = readQty(inp) + dir; if (q < 0) { q = 0; }
    inp.value = q; clampInput(inp, true);
    render(root());
  }

  /* ---------- olay bağlama (delegasyon: .bbx swap edilir) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) { return; }
    var bx = closest(t, '.bbx');
    var sw = closest(t, '.bbx-sw, .bbx-color-item');
    if (sw && bx) { e.preventDefault(); closeList(bx); selectColor(sw.getAttribute('data-value-id'), sw.getAttribute('data-name')); return; }
    var stp = closest(t, '.bbx-inc, .bbx-dec');
    if (stp && bx) { e.preventDefault(); step(stp, stp.classList.contains('bbx-inc') ? 1 : -1); return; }
    if (closest(t, '.bbx-atc') && bx) { e.preventDefault(); addToCart(bx); return; }
    var sb = closest(t, '.bbx-sticky-btn');
    if (sb && bx) {
      e.preventDefault();
      if (compute(bx).n) { addToCart(bx); }
      else { var m = qs('.bbx-matrix', bx); if (m) { m.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }
      return;
    }
    if (closest(t, '.bbx-colors-toggle, .bbx-colors-cur') && bx) { e.preventDefault(); toggleList(bx); return; }
    if (closest(t, '.bbx-color-close') && bx) { e.preventDefault(); closeList(bx); return; }
    var rm = closest(t, '.bbd-more');
    if (rm) {
      e.preventDefault();
      var cl = rm.parentNode && rm.parentNode.querySelector('.bbd-clamp'); var on = !(cl && cl.classList.contains('is-open'));
      if (cl) { cl.classList.toggle('is-open', on); } rm.classList.toggle('is-open', on); rm.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (!on && cl) { var top = cl.getBoundingClientRect().top; if (top < 0) { window.scrollBy(0, top - 90); } }
      return;
    }
    var more = closest(t, '.bbx-sw-more');
    if (more && bx) {
      e.preventDefault();
      var w = qs('.bbx-sw-wrap', bx); var on = !(w && w.classList.contains('is-expanded'));
      if (w) { w.classList.toggle('is-expanded', on); } more.setAttribute('aria-expanded', on ? 'true' : 'false');
      fitMore(bx);
      return;
    }
    if (!closest(t, '.bbx-color-list')) { closeList(); }
  });
  document.addEventListener('mouseover', function (e) {
    var t = e.target; if (!t || !t.closest) { return; }
    var sw = closest(t, '.bbx-sw, .bbx-color-item'); var bx = sw && closest(sw, '.bbx'); if (!sw || !bx) { return; }
    if (bx.classList.contains('is-loading')) { return; }
    previewColor(bx, sw); if (sw.classList.contains('bbx-sw')) { showTip(bx, sw); }
  });
  document.addEventListener('mouseout', function (e) {
    var t = e.target; if (!t || !t.closest) { return; }
    var sw = closest(t, '.bbx-sw, .bbx-color-item'); var bx = sw && closest(sw, '.bbx'); if (!sw || !bx) { return; }
    var to = e.relatedTarget; if (to && closest(to, '.bbx-sw, .bbx-color-item') === sw) { return; }
    restoreColor(bx); hideTip(bx);
  });
  document.addEventListener('input', function (e) {
    var t = e.target; if (!t || !t.classList) { return; }
    if (t.classList.contains('bbx-qty')) { clampInput(t, false); render(root()); }
    else if (t.classList.contains('bbx-color-search')) { var bx = closest(t, '.bbx'); if (bx) { filterList(bx, t.value); } }
  });
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.classList) { return; }
    if (t.classList.contains('bbx-qty')) { clampInput(t, true); render(root()); }
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key === 'Enter' && t && t.classList && t.classList.contains('bbx-qty')) { e.preventDefault(); t.blur(); return; }
    if (e.key === 'Escape') { closeList(); }
  });
  document.addEventListener('focusin', function (e) {
    var t = e.target; if (t && t.classList && t.classList.contains('bbx-qty')) { try { t.select(); } catch (err) {} }
  });

  function init() {
    var bx = root(); if (!bx) { return; }
    sortSwatches(bx); syncSticky(bx);
    render(bx); initSticky(bx); loadCart();
    scrollSwatchIntoView(bx);
    addGalleryBadge(); initReadMore();
    window.addEventListener('resize', function () { var b = root(); if (b) { fitMore(b); } initReadMore(); });
    /* Ilk yuklemede URL'de ?variant varsa (renk kartindan/yenilemeden gelis) galeri o rengin gorseline atlasin;
       Flickity sonradan hazir olabilir → kisa denemeler. ?variant yoksa tema galerisi ilk (lifestyle) gorselde kalir. */
    try {
      if (/[?&]variant=/.test(location.search) && bx.getAttribute('data-media-id')) {
        var tries = 0, mid = bx.getAttribute('data-media-id');
        var t = setInterval(function () {
          tries += 1;
          var slider = document.querySelector('[data-product-main-slider]');
          var fl = slider && window.Flickity && Flickity.data(slider);
          if (fl || tries >= 12) { clearInterval(t); selectMedia(mid); }
        }, 250);
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  window.BearBlank = { selectColor: selectColor, addToCart: function () { addToCart(root()); }, refresh: function () { render(root()); }, reloadCart: loadCart, money: money, moneyShort: moneyShort };
})();
